import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueMobileDetection from "vue-mobile-detection";
import './assets/main.css'

const app = createApp(App).use(store).use(router).use(VueMobileDetection)
// 關閉 Vue 的警告和錯誤提示
app.config.warnHandler = () => {}
app.config.errorHandler = () => {}
app.mount('#app')
